<script setup>
import IndexNavbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import {onMounted, ref, computed} from "vue";
//axios请求
import {inject} from 'vue'
import {ArrowRight} from '@element-plus/icons-vue'
import {ElLoading, ElMessage} from "element-plus";
import Plotly from 'plotly.js-dist'

onMounted(() => {
});
const $axios = inject('$axios')
const rna_seqList = ref([])
const corrlist = ref([])
const inputText = ref('')
const rna_seqList2 = ref([])
//分页器

// 默认显示第几页
const currentPage = ref(1)
// 个数选择器（可修改）
let pageSizes = [20, 50, 100, 200, 300, 400]
// 默认每页显示的条数（可修改）
const PageSize = ref(20)

// 显示第几页
function handleCurrentChange(val) {
  // 改变默认的页数
  currentPage.value = val
}

function handleSizeChange(val) {
  // 改变每页显示的条数
  PageSize.value = val
  // 注意：在改变每页显示的条数时，要将页码显示到第一页
  currentPage.value = 1
}

function inputInput(e) {
  inputText.value = e.target.value;
}

const geneText = ref('ATP6')

function geneInput(e) {
  geneText.value = e.target.value;
}

const expressionData = ref([])
const expressionType = ref('Gene')      // 或 Trans / Single 等
const bioProject = ref('all')

async function fetchData() {
  const loadingInstance = ElLoading.service({
    fullscreen: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
    lock: true
  })

  try {

    const params = {
      input: geneText.value,
      type: expressionType.value,
      bioproject: bioProject.value
    }

    const res = await $axios.get(
        'http://bioinfo-sysu.com:8383/api/get_expression',
        {params}
    )

    expressionData.value = res.data || []

    drawBoxPlot()

  } catch (err) {
    console.error(err)
    ElMessage.error('Failed to fetch data')
  }

  loadingInstance.close()
}

function drawBoxPlot() {
  if (!expressionData.value || expressionData.value.length === 0) {
    Plotly.purge('boxPlot')
    return
  }

  const filtered = expressionData.value.filter(d => d.expression !== null && d.expression !== undefined && !isNaN(d.expression));
  const tissuesAll = expressionData.value.map(d => d.tissue);
  const uniqueTissues = Array.from(new Set(tissuesAll));
  const tissueCount = uniqueTissues.length;

  const container = document.getElementById('boxPlot');
  const wrapper = document.getElementById('boxPlotWrapper') || container.parentElement;

  const parentWidth = wrapper.clientWidth;
  const parentHeight = 600;
  container.style.width = '100%';
  container.style.height = parentHeight + 'px';

  const baseFontSize = Math.max(14, parentWidth / 80);
  const titleFontSize = baseFontSize * 1.3;
  const axisTitleFontSize = baseFontSize * 1.1;
  const tickFontSize = baseFontSize * 0.9;
  const legendFontSize = baseFontSize * 0.8;

  const colors = [
    '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
    '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
    '#aec7e8', '#ffbb78', '#98df8a', '#ff9896', '#c5b0d5',
    '#c49c94', '#f7b6d2', '#c7c7c7', '#dbdb8d', '#9edae5'
  ];

  const traces = uniqueTissues.map((tissue, idx) => {
    const subset = filtered.filter(d => d.tissue === tissue)
    const color = colors[idx % colors.length]

    // bioProject ≠ all → 柱状图
    if (bioProject.value !== 'all') {
      return {
        x: subset.map(d => d.sample),
        y: subset.map(d => d.expression),
        text: subset.map(d => d.sample),
        customdata: subset.map(d => d.project),

        type: 'bar',
        name: tissue,

        marker: {
          color: subset.map((_, i) => colors[i % colors.length]),
          opacity: 0.8
        },

        hovertemplate:
            '<b>Sample:</b> %{text}<br>' +
            '<b>Project:</b> %{customdata}<br>' +
            '<b>Expression:</b> %{y:.3f}<extra></extra>'
      }
    }

// bioProject = all → 原来的箱线图
    return {
      y: subset.map(d => d.expression),
      x: subset.map(_ => tissue),
      text: subset.map(d => d.sample),
      customdata: subset.map(d => d.project),

      type: 'box',
      name: tissue,
      boxpoints: 'all',
      jitter: 0.3,
      pointpos: 0,

      marker: {
        size: Math.max(3, 6 - tissueCount * 0.1),
        color: color,
        opacity: 0.6
      },

      line: {
        width: 2,
        color: color
      },

      width: 0.8,

      hovertemplate:
          '<b>Sample:</b> %{text}<br>' +
          '<b>Project:</b> %{customdata}<br>' +
          '<b>Tissue:</b> %{x}<br>' +
          '<b>Expression:</b> %{y:.3f}<extra></extra>'
    }
  })

  let tickAngle = -30;
  if (tissueCount > 15) tickAngle = -45;
  if (tissueCount > 25) tickAngle = -60;
  if (tissueCount > 40) tickAngle = -75;

  const rightMargin = tissueCount > 10 ? 180 : 150;

  const layout = {
    width: parentWidth,
    height: parentHeight,
    font: {size: baseFontSize, family: 'Arial, sans-serif'},
    title: {
      text: `Bulk tissue ${expressionType.value} expression — ${geneText.value}`,
      font: {size: titleFontSize, weight: 'bold'},
      x: 0.5, xanchor: 'center', y: 0.98
    },
    yaxis: {
      title: {text: 'Expression', font: {size: axisTitleFontSize, weight: 'bold'}},
      tickfont: {size: tickFontSize},
      zeroline: true, zerolinewidth: 1, zerolinecolor: '#ccc',
      gridcolor: '#f0f0f0', showgrid: true, automargin: true
    },
    xaxis: {
      title: {
        text: bioProject.value === 'all' ? 'Tissues' : 'Samples', font: {size: axisTitleFontSize, weight: 'bold'}
      },
      tickangle: tickAngle,
      tickfont: {size: tickFontSize},
      automargin: true,
      showgrid: false
    },
    boxmode: 'group',
    boxgap: 0.2,
    boxgroupgap: 0.1,
    margin: {t: 70, b: Math.max(80, 40 + tissueCount * 1.5), l: 70, r: rightMargin},
    plot_bgcolor: 'white',
    paper_bgcolor: 'white',
    showlegend: bioProject.value === 'all',
    legend: {
      orientation: 'v',
      x: 1.02, y: 1,
      xanchor: 'left', yanchor: 'top',
      bgcolor: 'rgba(255,255,255,0.9)',
      bordercolor: '#ccc', borderwidth: 1,
      font: {size: legendFontSize}, itemwidth: 30
    },
    hovermode: 'closest',
    autosize: false
  }

  const config = {
    responsive: false,
    displaylogo: false,
    modeBarButtonsToRemove: ['lasso2d', 'select2d'],
    toImageButtonOptions: {
      format: 'png',
      filename: `GeneBoxPlot_${geneText.value}`,
      width: parentWidth,
      height: parentHeight,
      scale: 2
    }
  }

  container.innerHTML = ''
  Plotly.newPlot('boxPlot', traces, layout, config).then(() => {
    setTimeout(() => {
      Plotly.Plots.resize('boxPlot');
    }, 100);
  });
}

// 添加窗口大小变化监听，确保图表始终填满容器
window.addEventListener('resize', function () {
  if (typeof drawBoxPlot === 'function') {
    setTimeout(drawBoxPlot, 200);
  }
});


const sortCorNum = ref(1)

function sortCor() {
  if (sortCorNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortCorNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].correlation)
      var nameB = parseFloat(b['fields'].correlation)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortCorNum.value = 1
  }
}

const sortPNum = ref(1)

function sortP() {
  if (sortPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].pvalue)
      var nameB = parseFloat(b['fields'].pvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortPNum.value = 1
  }
}

const sortAPNum = ref(1)

function sortAP() {
  if (sortAPNum.value) {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    sortAPNum.value = 0
  } else {
    rna_seqList2.value.sort(function (a, b) {
      var nameA = parseFloat(a['fields'].adjpvalue)
      var nameB = parseFloat(b['fields'].adjpvalue)
      if (nameA < nameB) {
        return 1
      }
      if (nameA > nameB) {
        return -1
      }
      return 0
    })
    sortAPNum.value = 1
  }
}

const loadtable = ref(false)

// const downloadFile = (fileName) => {
//   // 文件路径（假设文件名为data.csv）
//   const filePath = './file/' +fileName// 文件位于public目录下
//
//   // 创建隐藏的可下载链接
//   const link = document.createElement('a')
//   link.href = filePath
//   link.download = fileName // 设置下载文件名
//
//   // 添加到DOM并触发点击
//   document.body.appendChild(link)
//   link.click()
//
//   // 清理DOM
//   document.body.removeChild(link)
// };
</script>
<template>
  <div>
    <index-navbar/>
    <section class="relative w-full h-full py-40 min-h-screen">
      <div class="container mx-auto items-center flex flex-wrap">
        <div class="col-12 my-3">
          <el-breadcrumb :separator-icon="ArrowRight" style="font-size: 22px">
            <el-breadcrumb-item :to="{ path: '/' }"><i class="bi bi-house me-1"></i>Home</el-breadcrumb-item>
            <el-breadcrumb-item>Expression</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="col-12">
          <div class="border-t border-blueGray-200 text-center">
            <div class="flex flex-wrap justify-center">
              <div class="w-full lg:w-9/12 px-4">
                <p class="text-lg leading-relaxed text-blueGray-700">
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="col-md-6">-->
        <!--          <img :src="UMAP_celltype">-->
        <!--        </div>-->
        <!--        <div class="col-md-6">-->
        <!--          <img :src="edit_FeaturePlot">-->
        <!--        </div>-->
        <div class="col-12 my-6 ">
          <span class="font-bold">Gene Expression：</span>
          <div class="text-center mt-12 d-flex flex-column">
            <div class="d-flex flex-row justify-content-center align-items-center">
              <span class="font-bold">Type:</span>
              <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example"
                      v-model="expressionType"
                      style="width: 15%; color: #ccc;">
                <option value="Gene" style="color: black;">Gene</option>
                <option value="Trans" style="color: black;">Transcript</option>
              </select>
              <span class="font-bold">Bioproject:</span>
              <select class="form-select form-select-lg mx-4" aria-label=".form-select-lg example" v-model="bioProject"
                      style="width: 15%; color: #ccc;">
                <option value="all" style="color: black;">all</option>
                <option value="PRJNA421440" style="color: black;">PRJNA421440</option>
                <option value="PRJDB6524" style="color: black;">PRJDB6524</option>
                <option value="PRJDB683" style="color: black;">PRJDB683</option>
                <option value="PRJNA183205" style="color: black;">PRJNA183205</option>
                <option value="PRJNA197323" style="color: black;">PRJNA197323</option>
                <option value="PRJNA221360" style="color: black;">PRJNA221360</option>
                <option value="PRJNA260223" style="color: black;">PRJNA260223</option>
                <option value="PRJNA331084" style="color: black;">PRJNA331084</option>
                <option value="PRJNA360217" style="color: black;">PRJNA360217</option>
                <option value="PRJNA480530" style="color: black;">PRJNA480530</option>
                <option value="PRJNA514182" style="color: black;">PRJNA514182</option>
                <option value="PRJNA530174" style="color: black;">PRJNA530174</option>
                <option value="PRJNA533704" style="color: black;">PRJNA533704</option>
                <option value="PRJNA561276" style="color: black;">PRJNA561276</option>
                <option value="PRJNA564687" style="color: black;">PRJNA564687</option>
                <option value="PRJNA594187" style="color: black;">PRJNA594187</option>
                <option value="PRJNA629998" style="color: black;">PRJNA629998</option>
                <option value="PRJNA639300" style="color: black;">PRJNA639300</option>
                <option value="PRJNA640433" style="color: black;">PRJNA640433</option>
                <option value="PRJNA657327" style="color: black;">PRJNA657327</option>
                <option value="PRJNA657746" style="color: black;">PRJNA657746</option>
                <option value="PRJNA669454" style="color: black;">PRJNA669454</option>
                <option value="PRJNA675314" style="color: black;">PRJNA675314</option>
                <option value="PRJNA693158" style="color: black;">PRJNA693158</option>
                <option value="PRJNA714229" style="color: black;">PRJNA714229</option>
                <option value="PRJNA715841" style="color: black;">PRJNA715841</option>
                <option value="PRJNA724037" style="color: black;">PRJNA724037</option>


              </select>
              <span>Gene:</span>
              <input type="text" placeholder="chr14:106539192:CT" @input="geneInput" :value="geneText"
                     class="mx-3 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline"/>
              <button
                  class="mx-3 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  @click="fetchData">
                Submit
              </button>
            </div>
          </div>
          <div class="panel-content mt-5">
            <div class="expression-header">
              <div id="boxPlot" style="width: 100%; height: 600px"></div>
            </div>
          </div>
        </div>
      </div>

    </section>

    <footer-component/>
  </div>
</template>
